<template>
  <div class="fourElements">
    <div class="fourElementsContainer">
      <div class="oh fl mr20">
        <div class="fl lh30">品牌：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.brandId"
            style="width: 120px"
            @change="fourElementChange"
          >
            <a-select-option
              :value="item.id"
              :key="key"
              v-for="(item, key) in brands"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
      </div>

      <div class="oh fl mr20">
        <div class="fl lh30">渠道：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.channelId"
            style="width: 120px"
            @change="fourElementChange"
          >
            <a-select-option
              :value="item.id"
              :key="key"
              v-for="(item, key) in channels"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
      </div>

      <div class="oh fl  mr20">
        <div class="fl lh30">站点：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.siteId"
            style="width: 120px"
            @change="fourElementChange"
          >
            <a-select-option
              :value="item.id"
              :key="key"
              v-for="(item, key) in sites"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
      </div>
      <div class="oh fl">
        <div class="fl lh30">终端：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.terminalId"
            style="width: 120px"
            @change="fourElementChange"
          >
            <a-select-option :value="1" key="web">WEB</a-select-option>
            <a-select-option :value="2" key="app">APP</a-select-option>
          </a-select>
        </div>
      </div>
    </div>
    <div class="tar">
      <a-button class="mr10" @click="handleSetting">设置</a-button>
      <a-button
        type="primary"
        @click="() => jumpPage('NavigationDetail', { ...searchParams })"
        >新建导航</a-button
      >
    </div>
  </div>
  <a-modal
    v-model:visible="visible"
    title="设置"
    @ok="handleOk"
    okText="保存"
    cancelText="取消"
  >
    <div class="modal-content">
      <template v-if="searchParams.terminalId === 1">
        <div class="mb10">
          <a-checkbox v-model:checked="keyPC.switchKey">
            开启PC端导航赛马功能
          </a-checkbox>
        </div>
        <a-checkbox v-model:checked="keyM.switchKey">
          开启M端导航赛马功能
        </a-checkbox>
      </template>
      <template v-else>
        <a-checkbox v-model:checked="keyApp.switchKey">
          开启APP导航赛马功能
        </a-checkbox>
      </template>
    </div>
  </a-modal>
</template>
<script>
import { inject, toRefs } from 'vue'
import { useNavigation } from '../hooks'
export default {
  setup() {
    const state = inject('initState')

    return {
      ...toRefs(useNavigation(state.searchParams)),
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
.fourElements {
  background: #ffffff;
  padding: 10px 20px 20px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.fourElementsContainer {
  display: flex;
  flex-direction: row;
}
</style>
